import { BiSearch } from "react-icons/bi";
import { defineType } from "sanity";

export default defineType({
  name: "search",
  title: "Search Page",
  icon: BiSearch,
  type: "document",
  groups: [
    {
      name: "seo",
      title: "SEO, Routing & Tracking"
    }
  ],
  fields: [
    {
      name: "metadata",
      title: "SEO, Routing & Tracking",
      type: "metadata",
      group: "seo"
    }
  ],
  preview: {
    prepare(value) {
      return {
        title: "Search Page"
      };
    }
  }
});
